import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';

import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { CommonService } from '../../../_services/common.service';
import { UserService } from '../../../_services/user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-edit-profile',
	templateUrl: './edit-profile.component.html',
	styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {
	editProfileForm!: FormGroup;
	loading = false;
	submitted = false;
	userInfo: any;
	profile_pic: any = 'assets/images/edit-profile-pic.png';
	@Output() response: EventEmitter<boolean> = new EventEmitter();
	constructor(
		private formBuilder: FormBuilder,
		private commonService: CommonService,
		private userService: UserService,
		    private dialogRef: MatDialogRef<EditProfileComponent>,
           @Inject(MAT_DIALOG_DATA) public data: any 
	) { }

	

	 ngOnInit() {
    this.userInfo = this.userService.getUserInfo();
    this.profile_pic = this.userInfo.logo || 'assets/images/edit-profile-pic.png';
    this.editProfileForm = this.formBuilder.group({
      firstName: [this.userInfo.firstName || null, Validators.required],
      lastName: [this.userInfo.lastName || null],
      email: [this.userInfo.email || null, [Validators.required, Validators.email]],
      mobile: [
        this.userInfo.mobile || null,
        [Validators.required, Validators.pattern(/^(\+\d{1,3}[- ]?)?\d{10}$/)]
      ],
      profile_pic: [this.userInfo.logo || null]
    });
  }

  get editProFrm() {
    return this.editProfileForm.controls;
  }

	onFileChange(event:any) {
		if (event.target.files && event.target.files.length > 0) {
			const file = event.target.files[0];
			this.editProfileForm!.get('profile_pic')!.setValue(file);
			this.commonService.getBase64(event.target.files[0]).then((res) => {
				this.profile_pic = res;
			});
		}
	}

	 editProfile() {
    this.submitted = true;
    if (this.editProfileForm.invalid) return;

    const formdata = new FormData();
    formdata.append('email', this.editProfileForm.get('email')!.value);
    formdata.append('firstName', this.editProfileForm.get('firstName')!.value);
    formdata.append('lastName', this.editProfileForm.get('lastName')!.value);
    formdata.append('mobile', this.editProfileForm.get('mobile')!.value);
    formdata.append('profile_pic', this.editProfileForm.get('profile_pic')!.value);

    this.userService.updateProfile(formdata).subscribe(
      (res: any) => {
        if (res?.success) {
          this.userService.storeUserInfo(res.data);
          this.dialogRef.close(res); // ✅ success close
        } else {
          this.commonService.showError('', res.message);
        }
      },
      (err: any) => {
        this.commonService.showError('', err?.error?.message || 'Something went wrong');
      }
    );
  }

  closeModal() {
    this.dialogRef.close(); // ✅ simple close
  }
}
